import React from 'react'

import SignupForm from 'components/Auth/AuthForms/SignupForm'
import AuthFormWrapper from 'components/Auth/AuthFormWrapper'

const SignupPage = () => {
    return (
        <AuthFormWrapper>
            <SignupForm />
        </AuthFormWrapper>
    )
}

export default SignupPage
